module.exports = __webpack_public_path__ + "static/media/settings.6e7625aa.svg";